import * as yup from 'yup';

import {MS_MAX_PULL_CALS, PROVIDER_TYPE} from 'Utils/consts';

export const CONFLICT_SETTING_VIEW = Object.freeze({
  CALENDARS: 'calendars',
  EVENTS: 'events',
});

/**
 *
 * @param {string} val
 * @param {Account} account
 * @return {Object}
 */
export const getAvailabilityPreferenceDefault = (val, account) => {
  // convert array to object of true key values
  const defaultObj = val?.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {});

  const serviceCalendars = account?.calendars ?? [];
  const pullServiceCalendars = account?.pullCalendarIds ?? [];

  return {
    meta: {
      currentTabView: CONFLICT_SETTING_VIEW.CALENDARS,
    },
    busyEventTypes: {
      busy: defaultObj?.busy ?? true,
      tentative: defaultObj?.tentative ?? false,
      workingElsewhere: defaultObj?.workingElsewhere ?? false,
      oof: defaultObj?.oof ?? false,
    },
    checkCalendars: serviceCalendars.map((cal) => ({
      checked: pullServiceCalendars.includes(cal.id),
      name: cal.name,
      id: cal.id,
    })),
  };
};

/**
 * @param {*} t
 * @param {Account} account
 * @return {Object}
 */
export const getAvailabilityPreferenceSchema = (t, account) => {
  return yup.object({
    busyEventTypes: yup.object({
      busy: yup.boolean(),
      tentative: yup.boolean(),
      workingElsewhere: yup.boolean(),
      oof: yup.boolean(),
    }),
    checkCalendars: account?.service === PROVIDER_TYPE.OUTLOOK_CALENDAR ?
      yup.array().test('max4Cals', t('integration.errorO365MaxSelect4'), (value) => {
        return value.filter((item) => item.checked).length <= MS_MAX_PULL_CALS;
      }) :
      yup.array(),
  });
};
